import { Prose, MdxComponent } from '@it-incubator/mdx-components'
import { useScrollToAnchor } from 'common/hooks'

import s from './MDXContent.module.scss'

import { TableOfContents } from './toc/toc'
import { NodeData } from './toc/toc-node.types'

export const MDXContent = ({ code, tocMap }: { code: string; tocMap: NodeData }) => {
  useScrollToAnchor(code)

  return (
    <div className={s.container}>
      <div className={s.proseRoot}>
        <Prose>
          <MdxComponent code={code} />
        </Prose>
      </div>
      <div className={s.tocContainer}>
        <TableOfContents tocMap={tocMap} />
      </div>
    </div>
  )
}
